module.exports = __webpack_public_path__ + "img/dial.1093f82a.svg";